import { media } from "@/styles/media";
import { IFontProps, TDetailInfo } from "@/typings/Props";
import { useTranslation } from "react-i18next";
import styled, { keyframes } from "styled-components";

type TOwnProps = {
  $isPartial: boolean;
};

export default function DetailInfoBox(info: TDetailInfo) {
  const { t } = useTranslation();

  return (
    <BoxWrapper $isPartial={info.isPartial}>
      <PTitle $fontSize="2rem" $fontWeight="700" data-aos="fade-right" data-aos-duration="1000">
        {t(info.title)}
      </PTitle>
      {/* <PContent id="desc" $fontColor="#444444" $lineHeight="150%"> */}
      <PContent id="desc" $fontColor="#444444" $lineHeight="25px">
        {t(info.desc)}
      </PContent>
    </BoxWrapper>
  );
}

const BoxWrapper = styled.div<TOwnProps>`
  width: ${(props) => (props.$isPartial ? "45%" : "100%")};
  height: auto;
  padding: ${(props) => (props.$isPartial ? "36px" : "42px")};
  overflow: hidden;
  align-items: center;
  flex-grow: 1;
  border-radius: 20px;
  background-color: white;
  transition: 0.4s ease;

  &:hover {
    color: white;
    background-color: #971b2f;
    transition: 0.3s ease-out;

    & > #desc {
      transition: 0.3s ease-out;
      color: white;
    }
  }

  ${media.tablet`
    width: 100%;
      margin: 0;
  `}
`;

const PTitle = styled.p<IFontProps>`
  font-family: "Lato Bold";
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  padding-bottom: 8px;
`;

const slideUp = keyframes`    
  from {
      transform: translateY(40vh); 
    }
  to {
      transform: translateY(0);
  }
`;

const PContent = styled.p<IFontProps>`
  font-family: Hind, sans-serif;
  font-size: ${(props) => props.$fontSize};
  font-weight: ${(props) => props.$fontWeight};
  line-height: ${(props) => props.$lineHeight};
  color: ${(props) => props.$fontColor};
  animation: ${slideUp} 5s ease-out forwards;
`;
